<!-- 首页最新资讯列表：图片（左）+标题+描述 -->
<template>
<div class="info-block">
  <router-link class="info-block-a" :to="'/hyzx/details/'+info.id" :title="info.title" v-bind:style="{backgroundImage:'url('+info.cover_img+')'}" target="_blank" >
    <div class="title">{{info.title.length>titleLength?(info.title.substring(0,titleLength)+'...'):info.title}}</div>
    <div class="label">{{info.description.length>labelLength?(info.description.substring(0,labelLength)+'...'):info.description}}</div>
  </router-link>
</div>
</template>
<script>
export default {
  name: 'InfoBlock08',
  props: {
    info: {
      type: Object,
      default: {}
    },
    infoIndex: {
      type: Number,
      default: 0
    },
    infoPre: {
      type: Object,
      default: function(){return {}}
    },
    infoNext: {
      type: Object,
      default: function(){return {}}
    },
    titleLength:{
      type:Number,
      default:10
    },
    labelLength:{
      type:Number|String,
      default:28
    }
  },
  data() {
    return {

    }
  },
  methods:{
    detailView(){
      let paramObje={id:this.info.id,infoPre:this.infoPre,infoNext:this.infoNext};
      //console.log("显示详情页参数："+JSON.stringify(paramObje));
      //let routeData=this.$router.resolve({path: '/hyzx/details',params:{id:96}});
      let routeData=this.$router.resolve({name: 'zxDetails',query:{idTest1:111,idTest2:222}});
      window.open(routeData.href, '_blank');
    },
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:border-box;
  height:75px;
  width:100%;
  padding:0px 5px 0px 120px;
  margin-bottom:15px;
  border:1px solid #fff;
  background-color: #fff;
  background-size: 110px 100%;
  background-repeat: no-repeat;
  background-position: 0px 0px;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
  border:1px solid #eee;
  color:var(--color6);
  cursor:pointer;
  //box-shadow:0px 0px 1px 1px orange;
}

.info-block .info-block-a:hover > .title{
  color:var(--color6);
}

.info-block-a .title{
  display:block;
  font-size:14px;
  font-weight:500;
  color:#282A2B;
  line-height:22px;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}

.info-block-a .label{
  display:block;
  padding-top:6px;
  font-size:12px;
  color:#9FA2A6;
  line-height:20px;
  color:#888;
}

</style>



// WEBPACK FOOTER //
// src/components/block/InfoBlock08.vue